const state = {
  token: '',
  id: '',
  usermsg: {},
  enterpriseNumber: null,
  sectionTree: [],
  username: '',
  accontPrice: []
}
const getters = {

}
const actions = {

}
const mutations = {
  getuserToekn (state, payload) {
    state.token = payload || ''
  },
  getUserName (state, payload) {
    state.username = payload || ''
  },
  getuserId (state, payload) {
    state.id = payload || ''
  },
  getusermsg (state, payload) {
    state.usermsg = payload || {}
  },
  getenterpriseNumber (state, payload) {
    state.enterpriseNumber = payload
  },
  getsectionTree (state, payload) {
    state.sectionTree = payload || []
  },
  getAccontPrice (state, payload) {
    state.accontPrice = payload || []
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js